import { IAssemblyApplicationTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { Detail } from 'components/detail/detail';
import { DetailsContainer, DetailsSection, Section } from 'components/detail/styled';
import { AssemblyTypeNameInlineEditor } from 'pages/Settings/AssemblyType/table_cells/AssemblyTypeNameInlineEditor';
import { AssemblyTypeStatusInlineEditor } from 'pages/Settings/AssemblyType/table_cells/AssemblyTypeStatusInlineEditor';
import { DebugValue } from 'shared/debug/DebugValue';

export type AssemblyTypeDetailsProps = Readonly<{
    assemblyType: IAssemblyApplicationTypeResponse;
    onUpdate: () => void;
}>;

export function AssemblyTypeDetails({
    assemblyType,
    onUpdate,
}: AssemblyTypeDetailsProps) {
    return (
        <DetailsContainer>
            <Section>
                <DebugValue value={assemblyType} description="Assembly Type" />
                <AssemblyTypeNameInlineEditor
                    assemblyType={assemblyType}
                    onUpdate={onUpdate}
                />
            </Section>
            <div className="px-48 mt-20">
                <DetailsSection>
                    <Detail name="Code">{assemblyType.Code}</Detail>
                    <Detail name="Status">
                        <AssemblyTypeStatusInlineEditor
                            assemblyType={assemblyType}
                            onUpdate={onUpdate}
                        />
                    </Detail>
                </DetailsSection>
            </div>
        </DetailsContainer>
    );
}
